import {Button, Space} from "antd";
import {StyledWidgetInfoBlock, StyledWidgetWrapper} from "../widget.style";
import {DownloadOutlined} from "@ant-design/icons";

export function ProfileTemplateWidget() {
  return (
    <StyledWidgetWrapper>
      {/* <h2 className="widget-heading">Free templates 🎨</h2> */}
      <h2 className="widget-heading">Free templates</h2>
      <div className="widget-card">
        <Space direction="vertical" size={12} style={{display: "flex"}}>
          <StyledWidgetInfoBlock style={{background: "#DFFCD8", color: "#1C1726"}}>
            <p>Download free Canva templates for your coaching journey</p>
          </StyledWidgetInfoBlock>
          <div style={{position: "relative"}}>
            {/* <StyledWidgetNewTag>
              <p className="new-text">New</p>
            </StyledWidgetNewTag> */}
            <Button
              href="https://www.canva.com/design/DAF5Z9ooe10/qoeG520d4A2LXtXXvtUf0w/view?utm_content=DAF5Z9ooe10&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
              block
              icon={<DownloadOutlined style={{fontSize: "1.6rem"}} />}
              size="small"
              target="_blank"
            >
              2025 coaching planner
            </Button>
          </div>
          <Button
            href="https://www.canva.com/design/DAGNQwXtt4M/7FnwSCRIPGJ97QDQfYW7Jw/view?utm_content=DAGNQwXtt4M&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
            block
            icon={<DownloadOutlined style={{fontSize: "1.6rem"}} />}
            size="small"
            target="_blank"
          >
            <span>Social media templates</span>
          </Button>
        </Space>
      </div>
    </StyledWidgetWrapper>
  );
}
